import {Component, inject, Input, OnInit} from '@angular/core';
import {FieldParameters} from '../../core/definitions/field-parameters';
import {CmsApiService} from '../../core/cms-api.service';
import {ObjectUsage} from '../../core/definitions/object-usage';
import {SearchReferenceService} from "../../core/search-reference.service";

@Component({
  selector: 'app-object-usage-field',
  templateUrl: './object-usage-field.component.html',
  styleUrls: ['./object-usage-field.component.scss'],
  standalone: false
})
export class ObjectUsageFieldComponent implements OnInit {
  // Injections
  private readonly cms: CmsApiService = inject(CmsApiService);
  private readonly searchReferenceService: SearchReferenceService = inject(SearchReferenceService);

  @Input() fieldParameters: FieldParameters;

  objectUsage: ObjectUsage;
  objectUsageCount = 0;
  lastShowUsage: ObjectUsage;
  objectUsageStart = 0;
  objectUsageRows = 50;

  ngOnInit(): void {
    this.setObjectUsage().then();
  }

  async setObjectUsage() {
    const reference = this.searchReferenceService.getSearchReferenceFromField(this.fieldParameters.field);
    const objectUsageRefProps = reference.ref_prop.split('.');
    const parentValue = objectUsageRefProps.length > 1 ?
      this.fieldParameters.rootObject[objectUsageRefProps[0]] : this.fieldParameters.rootObject;
    const parentValues = Array.isArray(parentValue) ? parentValue : [parentValue];
    const subProp = objectUsageRefProps[objectUsageRefProps.length - 1];
    const objectUsages: ObjectUsage[] = parentValues.filter(value => value[subProp] !== null).map(
      value => {
        return {
          objectId: value[subProp],
          objectName: value[`${subProp}_value`] || value.artifact_name,
          objectsUsing: []
        } as ObjectUsage;
      });
    if (objectUsages.length) {
      const usages = await this.cms.getSimpleConceptUsage({
        conceptId: objectUsages[0].objectId, start: this.objectUsageStart, rows: this.objectUsageRows
      });
      objectUsages[0].objectsUsing = usages?.artifacts ?? [];
      if (usages?.hits > 0) {
        this.objectUsageCount = usages.hits;
      }
    }
    this.objectUsage = objectUsages[0];
    this.fieldParameters.object[this.fieldParameters.field.name] = objectUsages;
  }

  nextItems(): void {
    this.objectUsageStart += this.objectUsageRows;
    this.setObjectUsage().then(() => {
      this.lastShowUsage = this.objectUsage;
      this.lastShowUsage.showItems = true;
    });
  }

  previousItems(): void {
    this.objectUsageStart  -= this.objectUsageRows;
    this.setObjectUsage().then(() => {
      this.lastShowUsage = this.objectUsage;
      this.lastShowUsage.showItems = true;
    })
  }

  toggleShowUsage(objectUsage: ObjectUsage) {
    if (this.lastShowUsage && this.lastShowUsage.objectId === objectUsage.objectId) {
      this.lastShowUsage.showItems = !this.lastShowUsage.showItems;
    } else {
      if (this.lastShowUsage) {
        this.lastShowUsage.showItems = false;
      }
      this.lastShowUsage = objectUsage;
      this.lastShowUsage.showItems = true;
    }
  }

}
